import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILED,
    LOGOUT_USER,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAILED,
    VERIFY_EMAIL,
    VERIFY_EMAIL_SUCCESS,
    VERIFY_EMAIL_FAILED,
    FORGET_PASSWORD,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAILED,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CLEAR_AUTH_ERROR,
} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
    error: null,
    needsVerification: false,
    verificationEmail: null,
    passwordResetStatus: null,
    resetCodeSent: false,
    passwordResetDone: false,
};

const Auth = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER:
            return { ...state, loading: true, error: null };
        case LOGIN_USER_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case LOGIN_USER_FAILED:
            return { ...state, error: action.payload, loading: false };

        case REGISTER_USER:
            return { ...state, loading: true, error: null, needsVerification: false };
        case REGISTER_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                needsVerification: true,
                verificationEmail: action.payload.email,
            };
        case REGISTER_USER_FAILED:
            return { ...state, error: action.payload, loading: false };

        case VERIFY_EMAIL:
            return { ...state, loading: true, error: null };
        case VERIFY_EMAIL_SUCCESS:
            return {
                ...state,
                user: action.payload,
                loading: false,
                error: null,
                needsVerification: false,
                verificationEmail: null,
            };
        case VERIFY_EMAIL_FAILED:
            return { ...state, error: action.payload, loading: false };

        case LOGOUT_USER:
            return { ...state, user: null };

        case FORGET_PASSWORD:
            return { ...state, loading: true, error: null, resetCodeSent: false };
        case FORGET_PASSWORD_SUCCESS:
            return {
                ...state,
                passwordResetStatus: action.payload,
                loading: false,
                error: null,
                resetCodeSent: true,
            };
        case FORGET_PASSWORD_FAILED:
            return { ...state, error: action.payload, loading: false };

        case RESET_PASSWORD:
            return { ...state, loading: true, error: null, passwordResetDone: false };
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                passwordResetStatus: action.payload,
                loading: false,
                error: null,
                passwordResetDone: true,
                resetCodeSent: false,
            };
        case RESET_PASSWORD_FAILED:
            return { ...state, error: action.payload, loading: false };

        case CLEAR_AUTH_ERROR:
            return { ...state, error: null };

        default:
            return { ...state };
    }
};

export default Auth;
